const { MONTHS, countyPhoneNumberData } = require("../utils/Constants");
// import Swal from 'sweetalert2';
module.exports = {
    formateDate: (dateString, showTime = true) => {
        let newStrDate = "";
        const date = new Date(dateString);
        newStrDate = MONTHS[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
        if (showTime) {
            const hour = date.getHours() == 0 ? 12 : (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
            const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            const secs = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            const ampm = date.getHours() < 12 ? 'AM' : 'PM';
            // newStrDate += ` ${hour}:${min}:${secs} ${ampm}`;
        }
        return newStrDate;
    },

    formateDateWithTime: (dateString, showTime = true) => {
        let newStrDate = "";
        const date = new Date(dateString);
        newStrDate = MONTHS[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();

        if (showTime) {
            const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
            newStrDate += `  ${time}`;
        }

        return newStrDate;
    },

    formatePickerDate: (dateString) => {
        const date = new Date(dateString);
        return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
    },

    Editorconvertercsv: (paragraph) => {
        let text = ""
        return text = paragraph ? paragraph.toString().replace(/(<([^>]+)>)/gi, "").replace(/(?:\\[rn]|[\r\n]+)+/g, "") : "-";
    },

    formateDataMultiSelect: (data, labelField, valueField) => {
        let newData = [];
        if (Array.isArray(data)) {
            data.forEach((item) => {
                let newItem = {
                    label: item[labelField],
                    value: item[valueField]
                };
                newData.push(newItem);
            });
        }
        return newData;
    },

    formateIdArray: (data, fromField) => {
        let newData = [];
        if (Array.isArray(data)) {
            data.forEach((item) => {
                newData.push(item[fromField]);
            });
        }
        return newData;
    },

    TrimText: (value, size = 40) => {
        return value != undefined && value.length > size ? value.slice(0, size) + "..." : value;
    },

    // logOutUser: () => {
    //     localStorage.clear();
    //     window.location.href = "/login";
    // },

    logOutUser: () => {

        if (localStorage.getItem('user')) {

            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = "/admin/login";

        }

    },

    logOutCompany: () => {

        if (localStorage.getItem('company_user')) {

            localStorage.removeItem('company_user');
            localStorage.removeItem('company_token');
            localStorage.removeItem('permission');
            localStorage.removeItem('outlet_id');
            localStorage.removeItem('company_detail');
            window.location.href = "/company/login";

        }

    },

    // logOutCompany: () => {

    //     if (localStorage.getItem('company_user')) {

    //         const user = JSON.parse(localStorage.getItem('company_user'));
    //         LogoutUserService({ id: user?.id })
    //             .then(() => {
    //                 console.log("Logout successfully")
    //                 localStorage.removeItem('company_user');
    //                 localStorage.removeItem('company_token');
    //                 localStorage.removeItem('permission');
    //                 localStorage.removeItem('outlet_id');
    //                 localStorage.removeItem('company_detail');
    //                 window.location.href = "/company/login";
    //             })
    //             .catch((error) => {
    //                 console.log("Error====>", error)
    //             })
    //     }
    // },

    setSessionKey: (key, value) => {
        sessionStorage.setItem(btoa(key), btoa(value));
    },

    getSessionKey: (key) => {
        if (sessionStorage.getItem(btoa(key))) {
            return atob(sessionStorage.getItem(btoa(key)));
        }
    },

    removeSessionKey: (key) => {
        return sessionStorage.removeItem(btoa(key));
    },

    getUser: function () {
        if (localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            return user;
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = "/admin/login";
        }
    },

    getCompany: function () {
        if (localStorage.getItem('company_user')) {
            const user = JSON.parse(localStorage.getItem('company_user'));
            return user;
        } else {
            localStorage.removeItem('company_user');
            localStorage.removeItem('company_token');
            window.location.href = "/company/login";
        }
    },

    getBrandId: function () {
        if (localStorage.getItem('brand_id')) {
            return localStorage.getItem('brand_id');
        } else {
            return null;
        }
    },

    getOutletId: function () {
        if (localStorage.getItem('outlet_id')) {
            return localStorage.getItem('outlet_id');
        } else {
            return null;
        }
    },
    getOutletBusinessDate: function () {
        const stored = localStorage.getItem('outlet_business_date');

        // ❌ null, "null", "undefined", empty string
        if (!stored || stored === 'null' || stored === 'undefined') {
            return new Date();
        }

        const date = new Date(stored);

        // ❌ Invalid Date check
        if (isNaN(date.getTime())) {
            return new Date();
        }

        return date;
    },

    // True when a date (an order's business_date) falls on the outlet's current
    // business day. Both are stored as the start of a business day, so the local
    // calendar day is compared. No date never matches.
    isOutletBusinessDay: function (value) {
        if (!value) return false;
        const date = new Date(value);
        if (isNaN(date.getTime())) return false;
        const outletDay = module.exports.getOutletBusinessDate();
        return date.getFullYear() === outletDay.getFullYear()
            && date.getMonth() === outletDay.getMonth()
            && date.getDate() === outletDay.getDate();
    },

    blockInvalidChar: (e) => {
        const str = 'eE+-.,;:/|\\!@#$%^&*()_=~`abcdefghijklmnopqrstuvwxyzABCEFGHIJKLMNOPQRSTUVWXYZ';
        return str.split('').includes(e.key) && e.preventDefault();
    },

    companyDetail: function () {
        if (localStorage.getItem('company_detail')) {
            return JSON.parse(localStorage.getItem('company_detail'));
        }
    },


    checkPermission: function (moduleName, permissionName) {
        const permissions = JSON.parse(localStorage.getItem('permission'));

        var permissionsCheck = false;
        if (permissions) {

            permissions.map(value => {

                if (value.module_slug == moduleName && value.permission_name == permissionName) {
                    permissionsCheck = true;
                    return;
                }
            });


        }
        return permissionsCheck;
    },

    getFirstAllowedRoute: function () {
        const permissions = JSON.parse(localStorage.getItem('permission')) || [];
        const viewSlugs = new Set();
        for (const p of permissions) {
            if (p.permission_name === 'view') viewSlugs.add(p.module_slug);
        }
        const routes = [
            ['store_dashboard', '/company/dashboard'],
            ['store_brands', '/company/business/brand/list/1'],
            ['store_outlets', '/company/business/outlet/list/1'],
            ['store_subscription', '/company/business/subscription'],
            ['store_platform_users', '/company/business/platform-user/outlet-user/list/1'],
            ['store_inventory_category', '/company/raw_materials/category/list/1'],
            ['store_inventory_subcategory', '/company/raw_materials/sub_category/list/1'],
            ['store_inventories', '/company/raw_materials/inventory/list/1'],
            ['store_suppliers', '/company/raw_materials/supplier_manage/list/1'],
            ['store_routing_groups', '/company/menu/routing-station/groups/list/1'],
            ['store_menu_category', '/company/menu/menu/categories/list/1'],
            ['store_waste_management', '/company/store_manager/waste_management/list/1'],
            ['store_transfer_in', '/company/store_manager/transfer_stock/transfer_in/list/1'],
            ['store_transfer_out', '/company/store_manager/purchase_order/list/1'],
            ['store_customers', '/company/crm/customers/list/1'],
            ['store_coupons', '/company/crm/coupons/coupon/list/1'],
            ['store_loyalty_points', '/company/crm/loyalty-points/list/1'],
            ['store_orders', '/company/transaction/order/list/1'],
            ['store_refund', '/company/transaction/refund/list/1'],
            ['store_transaction', '/company/transaction/transaction/list/1'],
            ['store_reports', '/company/report/sales_report/list/1'],
            ['store_erp', '/company/report/sales_report/list/1'],
            ['store_brand_sales_report', '/company/brand-report/sales_report/list/1'],
            ['store_brand_payment_report', '/company/brand-report/payment/list/1'],
            ['store_brand_item_cost_calculation_report', '/company/brand-report/item_cost/list/1'],
            ['store_brand_stock_movement_report', '/company/brand-report/stock_movement/list/1'],
            ['store_brand_erp_reports', '/company/brand-report/erp_sales/list/1'],
            ['store_brand_zatca_report', '/company/brand-report/zatca/list/1'],
            ['store_brand_discount_report', '/company/brand-report/discount/list/1'],
            ['store_brand_refund_report', '/company/brand-report/refund/list/1'],
            ['store_brand_waste_report', '/company/brand-report/waste/list/1'],
            ['store_settings', '/company/setting/tax-configuration/list/1'],
        ];
        for (const [slug, route] of routes) {
            if (viewSlugs.has(slug)) return route;
        }
        return '/company/login';
    },

    capitalizeFirstLetter: (str) => {
        if (str && str.length) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        } else {
            return "";
        }
    },

    capitalizeAllFirstLetters: (str) => {
        if (!str) return "";

        return str?.split(" ")?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(" ");
    },

    removeSpecialCharacter: (value) => {
        let text = "";
        try {
            text = String(value);
        } catch (err) {
            console.log(err);
        }
        if (text) {
            return text.replace("-", " ").replace("_", " ");
        }
        return "";
    },

    SpecialCharacter: (text) => {
        if (text) {
            return text.replace(/_/g, " ").replace("-", " ");
        } else {
            return "";
        }
    },

    removeHyphens: (text) => {
        if (text) {
            return text.replace(/-/g, " ");
        } else {
            return "";
        }
    },


    diffrenceBetweenTwoDates: (startDate, endDate) => {
        const date1 = new Date(startDate);
        const date2 = new Date(endDate);
        console.log("date2 - date1", date2 - date1);
        const diffTime = date2 - date1;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    },

    getDiffrenceInDays: (startDate, endDate) => {
        if (typeof startDate === "object") {
            startDate = startDate.toISOString().split("T")[0];
        }
        if (typeof endDate === "object") {
            endDate = endDate.toISOString().split("T")[0];
        }
        const date1 = new Date(startDate);
        const date2 = new Date(endDate);
        const diffTime = date2 - date1;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    },
    convertTo12Hour: (timeStr) => {
        let [hours, minutes, seconds] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${period}`;
    },

    handleServerValidations: (response) => {
        let message = response.message;
        if (Array.isArray(response.error)) {
            if (response.error[0] && response.error[0].msg) {
                message = response.error[0].msg;
            } else if (response.error[0] && response.error[0].message) {
                message = response.error[0].message;
            }
        }
        return message;
    },
    formatTime: (time) => {
        return time ? time.split(':').slice(0, 2).join(':') : "N/A";
    },
    getExtension: (fileName) => {
        const fileNameArr = fileName.split(".");
        return fileNameArr[fileNameArr.length - 1];
    },

    showLimitedElements: (arr, numToShow) => {
        if (!Array.isArray(arr) || typeof numToShow !== 'number' || numToShow < 0) {
            return 'Invalid input';
        }

        const elementsToShow = arr.slice(0, numToShow);
        const remainingElementsCount = arr.length - numToShow;

        let result = elementsToShow.join(', ');

        if (remainingElementsCount > 0) {
            result += `, and ${remainingElementsCount} more...`;
        }

        return result;
    },

    removeModalBackdrops: () => {
        const modals = document.querySelectorAll('.modal-backdrop');
        modals.forEach((item) => {
            item.remove();
        });
    },

    slugToReadable: (slug) => {
        if (!slug) return '';

        // Replace hyphens with spaces
        let readable = slug.replace(/-/g, ' ');

        // Capitalize the first letter of each word
        // readable = readable
        //     .toLowerCase()
        //     .replace(/\b\w/g, char => char.toUpperCase());

        return readable;
    },

    // An ERP failure is stored as { status, message, function }, but `message`
    // is whatever the ERP sent back: a string, or its own fault object
    // ({ Message, StackTrace, ExceptionType, ExceptionMessage }). React cannot
    // render that object, so flatten it to the most useful line of text.
    erpErrorText: (error) => {
        let value = error;
        if (value && typeof value === 'object' && 'message' in value) {
            value = value.message;
        }
        if (value === null || value === undefined || value === '') {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'object') {
            return value.ExceptionMessage || value.Message || value.message || value.error || JSON.stringify(value);
        }
        return String(value);
    },

    showPrice: (amount) => {
        if (!isNaN(amount) && amount !== null) {
            return Number(amount).toFixed(2);
        }
        return '0.00';
    },

    formatToTwoDecimals: (amount) => {
        const price = parseFloat(amount);
        return isNaN(price) ? 0.00 : price.toFixed(2);
    },

    formateDateWithMonth: (dateString, monthsToAdd = 0, showTime = true) => {
        let newStrDate = "";
        const date = new Date(dateString);

        // Add the specified number of months
        date.setMonth(date.getMonth() + monthsToAdd);

        newStrDate = MONTHS[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
        if (showTime) {
            const hour = date.getHours() === 0 ? 12 : (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
            const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            const secs = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            const ampm = date.getHours() < 12 ? 'AM' : 'PM';
            // Uncomment to include time in the format
            // newStrDate += ` ${hour}:${min}:${secs} ${ampm}`;
        }
        return newStrDate;
    },

    startOfDay: (date) => {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);  // Set time to 00:00:00
        return newDate;
    },

    endOfDay: (date) => {
        const newDate = new Date(date);
        newDate.setHours(23, 59, 59, 999);  // Set time to the end of the day 23:59:59.999
        return newDate;
    },

    generateLastNDaysDate: (numDays) => {
        const dates = [];
        const today = new Date();

        for (let i = 0; i < numDays; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() - i);
            // Format date to YYYY-MM-DD
            const formattedDate = date.toISOString().split('T')[0];
            dates.push(formattedDate);
        }

        return dates.reverse(); // Reverse to have oldest date first
    },

    generateDateRange: (startDate, endDate) => {
        const dates = [];
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Ensure start date is before end date
        if (start > end) return dates;

        let currentDate = new Date(start);

        while (currentDate <= end) {
            // Format date to YYYY-MM-DD
            const formattedDate = currentDate.toISOString().split('T')[0];
            dates.push(formattedDate);

            // Move to the next day
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    },

    addQueryParam: (url, key, value) => {
        const separator = url.includes('?') ? '&' : '?';
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set(key, value);
        console.log(`${url}${separator}${queryParams.toString()}`)
        return `${url}${separator}${queryParams.toString()}`;
    },

    isOnline: () => {
        return navigator.onLine;
    },

    getMobileLength: (countryCode) => {
        const codeAsString = String(Array.isArray(countryCode) ? countryCode[0] : countryCode); 
        if (countyPhoneNumberData[codeAsString]) {
            return countyPhoneNumberData[codeAsString].length;
        } else {
            return 10;
        }
    },

    // Excel column widths ('!cols') sized to each header and its longest cell, clamped to 10-60 characters
    getExcelColumnWidths: (rows, headers) => {
        return headers.map((header) => {
            let max = String(header).length;
            (rows || []).forEach((row) => {
                const value = row?.[header];
                if (value === null || value === undefined) return;
                String(value).split('\n').forEach((line) => {
                    if (line.length > max) max = line.length;
                });
            });
            return { wch: Math.min(Math.max(max + 2, 10), 60) };
        });
    }

};

